import axios from "axios";

const api = axios.create({
    // baseURL: process.env.REACT_APP_API_BASE_URL || `http://172.208.54.204:9400/v1.0`,
    // baseURL: `http://localhost:9401/v1.0`,
    // baseURL: `http://172.208.54.204:9400/v1.0`,
		baseURL: `https://cirrusoilapi.aoinnovations.org/v1.0`,
    // baseURL: `https://sotpro.cirrusoilgh.com/v1.0`,
    // baseURL: `https://moslapi.sotpro.net/v1.0`,
    headers: {
        'Content-Type': 'application/json'
    }
});

api.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('cirrus-token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            sessionStorage.removeItem('cirrus-company');
            sessionStorage.removeItem('cirrus-role');
            sessionStorage.removeItem('cirrus-user');
            sessionStorage.removeItem('cirrus-token');
            sessionStorage.removeItem('cirrus-cargo');
            sessionStorage.removeItem('cirrus-actual-cargo');
            window.location.replace('#/');
        }
        return Promise.reject(error);
    }
);

export default api;
